import { FormControl, ListItemText, OutlinedInput } from '@mui/material';
import { useState } from 'react';
import { Controller } from 'react-hook-form';
import { StyledCheckbox } from 'v3/shared/components/Checkbox';
import {
  InputLabelStyled,
  selectMenuPaperPropsStyle,
  StyledArrowDropDownIcon,
  StyledArrowDropUpIcon,
  StyledMenuItem,
  StyledSelect,
} from 'v3/shared/components/Inputs/MarkdownSelect/styles';

interface MarkdownSelectProps {
  name: string;
  control: any;
  options: { id: string; name: string }[];
  label: string;
  fullWidth?: boolean;
}

export default function MultipleSelectCheckmarksController({
  name,
  control,
  options,
  label,
  fullWidth,
}: MarkdownSelectProps) {
  const [open, setOpen] = useState(false);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={[]}
      render={({ field }) => (
        <FormControl fullWidth={fullWidth}>
          <InputLabelStyled>{label}</InputLabelStyled>
          <StyledSelect
            multiple
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            fullWidth={fullWidth}
            value={field.value || []}
            onChange={field.onChange}
            input={<OutlinedInput label={label} />}
            IconComponent={() =>
              open ? (
                <StyledArrowDropUpIcon
                  onClick={() => {
                    setOpen(!open);
                  }}
                />
              ) : (
                <StyledArrowDropDownIcon
                  onClick={() => {
                    setOpen(!open);
                  }}
                />
              )
            }
            renderValue={(value: unknown) =>
              options
                .filter((option) => (value as string[]).includes(option.id))
                .map((opt) => opt.name)
                .join(', ')
            }
            MenuProps={{
              PaperProps: selectMenuPaperPropsStyle,
            }}
          >
            {options.map((option) => (
              <StyledMenuItem key={option.id} value={option.id}>
                <StyledCheckbox checked={field.value.includes(option.id)} />
                <ListItemText primary={option.name} />
              </StyledMenuItem>
            ))}
          </StyledSelect>
        </FormControl>
      )}
    />
  );
}
